<template>
  <v-card
    flat
    class="pa-3 mt-1"
  >
    <v-card-title class="d-flex align-center justify-center py-0">
      <div
        class="d-flex align-center"
      >
        <v-img
          :src="require(`@/assets/images/logos/logo.png`)"
          max-width="300px"
          alt="logo"
          contain
          class="me-0 "
        ></v-img>
      </div>
    </v-card-title>
    <v-form class="multi-col-validation">
      <v-card-text class="pt-1">
        <p class="text-h6 text-center">Create New Njangi Group</p>
        <v-row>
          <v-col cols="10" class="py-0 my-1">
            <v-text-field
              v-model="admin_username"
              ref="admin_username"
              outlined dense
              label="Search njangi admin..."
            ></v-text-field>
          </v-col>

          <v-col cols="2" class="py-0 my-1">
            <v-btn
              color="success"
              class="me-3"
              fab small
              @click="getUsers()"
            >
              <font-awesome-icon icon="fa-solid fa-magnifying-glass" />
            </v-btn>
          </v-col>

          <v-col
            cols="12"
            class="py-0 my-1"
          >
            <v-select
              v-model="selected_admin"
              ref="selected_admin"
              :items="users"
              item-text="username"
              item-value="id"
              outlined dense
              label="Select the njangi admin"
            ></v-select>
          </v-col>

          <v-col cols="12" md="6" class="py-0 my-1">
            <v-text-field
              v-model="njangi_name"
              ref="njangi_name"
              outlined dense
              label="Enter the njangi name"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12" md="6"
            class="py-0 my-1"
          >
            <v-select
              v-model="njangi_cycle"
              ref="njangi_cycle"
              outlined
              dense
              :items="njangi_cycles"
              label="Select Njangi Cycle"
              @change="onCycleChange"
            ></v-select>
          </v-col>

          <v-col
            cols="12"
            sm="12"
            class="text-left mt-0 pt-0"
          >
            <v-text-field
              v-model="groupStartDate"
              ref="groupStartDate"
              dense
              type="date"
              label="Njangi Group Start Date "
            ></v-text-field>
          </v-col>

          <v-col
            cols="12" md="6"
            class="py-0 my-1"
          >
            <v-text-field
              v-model="njangi_contact"
              ref="njangi_contact"
              outlined
              dense
              label="Input Njangi Contact (2376XXXXXXXX)"
            ></v-text-field>
          </v-col>

          <!-- Updated: Contribution Amount with predefined values and fees -->
          <v-col
            cols="12" md="6"
            class="py-0 my-1"
          >
            <v-select
              v-model="njangi_amount"
              ref="njangi_amount"
              :items="contributionOptions"
              item-text="display_text"
              item-value="value"
              outlined
              dense
              :loading="loadingAmounts"
              :disabled="loadingAmounts || !njangi_cycle"
              label="Select Contribution Amount"
              @change="updateFeeDisplay"
            >
              <template v-slot:prepend-inner>
                <v-icon color="primary">mdi-currency-usd</v-icon>
              </template>
            </v-select>

            <!-- Fee Breakdown Display -->
            <v-alert
              v-if="selectedContribution && selectedContribution.fee > 0"
              type="info"
              dense
              class="mt-2"
              outlined
            >
              <div class="d-flex justify-space-between align-center mb-1">
                <span class="caption">Base Contribution:</span>
                <span class="caption font-weight-medium">{{ formatAmount(selectedContribution.value) }} F CFA</span>
              </div>
              <div class="d-flex justify-space-between align-center mb-1">
                <span class="caption" style="color: #ff9800;">Transaction Fee:</span>
                <span class="caption font-weight-medium" style="color: #ff9800;">+ {{ formatAmount(selectedContribution.fee) }} F CFA</span>
              </div>
              <v-divider class="my-1"></v-divider>
              <div class="d-flex justify-space-between align-center">
                <span class="body-2 font-weight-bold">Total to Pay:</span>
                                <span class="body-2 font-weight-bold">{{ formatAmount(selectedContribution.total) }} F CFA</span>
              </div>
            </v-alert>

            <v-alert
              v-if="!njangi_cycle"
              type="warning"
              dense
              class="mt-2"
              outlined
            >
              Please select a collection cycle first
            </v-alert>
          </v-col>

          <v-col cols="12" class="py-0 my-1">
            <v-file-input
              show-size
              v-model="njangi_image"
              ref="product_cover_image"
              truncate-length="18"
              style="cursor: pointer"
              label="Choose Njangi Image"
            ></v-file-input>
          </v-col>

          <v-col cols="12" >
            <v-text-field
                class="pa-0 mt-0"
                id="njangi_description"
                ref="njangi_description"
                v-model="njangi_description"
                label="Njangi Description"
                color="teal"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text class="text-end">
        <spinner v-if="loading" class="text-end"></spinner>
        <v-btn
          v-else
          color="primary"
          class="me-3 mt-3"
          @click="createNjangi()"
        >
          Create Njangi
        </v-btn>

      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { mdiKeyOutline, mdiLockOpenOutline, mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import axios from 'axios'
import Spinner from "@/components/Spinner.vue";

export default {
  components: {
    Spinner,
  },

  data() {
    return {
      loading: false,
      loadingAmounts: false,
      njangi_name: "",
      selected_admin: "",
      njangi_contact: "",

      njangi_cycle: "",
      njangi_amount: "",
      njangi_description: "",
      admin_username: "",

      njangi_cycles: ['Daily', 'Weekly', 'Monthly'],
      users: [],
      njangi_image: [],
      groupStartDate: "",

      // Contribution options with fees
      contributionOptions: [],
      selectedContribution: null,

      mdiKeyOutline,
      mdiLockOpenOutline,
      mdiEyeOffOutline,
      mdiEyeOutline,
    }
  },

  computed: {
    // Removed all weekly-specific validations
  },

  mounted(){
    // executes these after the page has been mounted
    document.title = "Manager: Njangi | Create Njangi"

    // Load contribution amounts for default cycle if needed
    if (this.njangi_cycle) {
      this.loadContributionAmounts()
    }
  },

  methods:{
    getUsers(){
      axios
        .get('/api/v1/manager/get/clients/'+this.admin_username+'/')
        .then(response => {
          this.users = response.data  // get the data and fill into users
          console.log(this.users)
        })
        .catch(error => {
          if (error.response){
            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
          }else{
            this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
          }
        })
    },

    async loadContributionAmounts() {
      if (!this.njangi_cycle) return

      this.loadingAmounts = true

      try {
        const response = await axios.get('/api/v1/njangi/contribution-amounts/', {
          params: { cycle: this.njangi_cycle }
        })

        this.contributionOptions = response.data.contributions

        // Reset selected contribution if cycle changed
        this.njangi_amount = ""
        this.selectedContribution = null

      } catch (error) {
        console.error('Error loading contribution amounts:', error)
        this.$store.commit('setSnackBarMessage', 'Error loading contribution amounts')
        this.$store.commit('setSnackBarColor', "red darken-4")
        this.$store.commit('activateSnackBar', true)
      } finally {
        this.loadingAmounts = false
      }
    },

    updateFeeDisplay() {
      if (this.njangi_amount) {
        this.selectedContribution = this.contributionOptions.find(
          opt => opt.value === this.njangi_amount
        )
      } else {
        this.selectedContribution = null
      }
    },

    formatAmount(amount) {
      return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    },

    onCycleChange() {
      // Load contribution amounts when cycle changes
      this.loadContributionAmounts()
    },

    async createNjangi(){
        if(this.selected_admin === ""){
            this.$store.commit('setSnackBarMessage', "Please select the njangi administrator.")
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
            this.$refs.selected_admin.focus()
        }
        else if(this.njangi_cycle === ""){
            this.$store.commit('setSnackBarMessage', "Please select the njangi cycle")
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
            this.$refs.njangi_cycle.focus()
        }
        else if(this.njangi_amount === "" || String(Number(this.njangi_amount)) === "NaN"){
          this.$store.commit('setSnackBarMessage', "Please select the njangi contribution amount")
          this.$store.commit('setSnackBarColor', "red darken-4")
          this.$store.commit('activateSnackBar', true)
          this.$refs.njangi_amount.focus()
        }
        else if(this.njangi_contact === ""){
            this.$store.commit('setSnackBarMessage', "Please input the njangi contact.")
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
        }
        else if(this.njangi_name === ""){
            this.$store.commit('setSnackBarMessage', "Please input the njangi name.")
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
        }
        else if(!this.njangi_image){
            this.$store.commit('setSnackBarMessage', "Please input the njangi image file.")
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
        }
        else if(this.njangi_description === ""){
            this.$store.commit('setSnackBarMessage', "Please give the njangi description.")
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
        }
        else {
            this.loading = true

            let formData = new FormData()
            formData.append('selected_admin_id', this.selected_admin)
            formData.append('njangi_cycle', this.njangi_cycle)
            // Date est maintenant optionnelle
            if (this.groupStartDate) {
                formData.append('groupStartDate', this.groupStartDate)
            }
            formData.append('njangi_amount', this.njangi_amount)
            formData.append('njangi_name', this.njangi_name)
            formData.append('njangi_image', this.njangi_image)
            formData.append('njangi_contact', this.njangi_contact)
            formData.append('njangi_description', this.njangi_description)

            await axios
                .post('/api/v1/manager/njangi/create/group/', formData, {headers: {'Content-Type': 'multipart/form-data'}})
                .then(response => {
                    console.log(response.data)
                    this.$store.commit('setSnackBarMessage', response.data[0].text)
                    this.$store.commit('setSnackBarColor', response.data[0].color)
                    this.$store.commit('activateSnackBar', true)
                    this.$store.commit('setSnackBarTimeOut', 4000)

                    if (response.data[0].category === "success"){
                      let router = this.$router
                      setTimeout(function(){
                          router.push('/njangi/view/groups')
                      }, 4000)
                    }
                })
                .catch(error => {
                    if (error.response){
                        this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
                        this.$store.commit('setSnackBarColor', "red darken-4")
                        this.$store.commit('activateSnackBar', true)
                    }else{
                        this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
                        this.$store.commit('setSnackBarColor', "red darken-4")
                        this.$store.commit('activateSnackBar', true)
                    }
                })

            this.loading = false
        }

    },
  },
}
</script>

<style scoped>
/* Add any custom styles if needed */
.caption {
  font-size: 0.75rem !important;
}

.body-2 {
  font-size: 0.875rem !important;
}
</style>
